const da = {
  home: {
    biometric_label: "BIOMETRISK IDENTITETSBEKRÆFTELSE",
    title: "Omvendt ansigtssøgning gjort nemt",
    description:
      "Upload et højopløsningsportræt til krydshenvisning mod globale digitale arkiver ved hjælp af avanceret neural matching.",
    drag_drop: "Træk og slip dit billede",
    file_formats: "Understøtter RAW, JPEG eller PNG (Maks 15MB)",
    select_file: "VÆLG FIL FRA SYSTEM",
    initiate_scan: "Start Kriminalteknisk Scanning",
    upload_hint: "UPLOAD ET BILLEDE FOR AT FORTSÆTTE",
    uploading: "Uploader",
    searching: "Scanner",
    result_title: "Resultater",
    drop_here: "Slip billedet her...",
    billion_faces: "Sammenlign med over 1 milliard ansigter på internettet",
    login_to_search: "Log ind for at søge",
    login_required: "Log ind eller opret en konto for at bruge denne app",
    not_enough_tokens: "Ikke nok tokens",
    please_wait: "Vent venligst et par minutter",
    leave_confirmation:
      "Der kører en proces. Er du sikker på, at du vil forlade siden?",
  },
  sources: {
    section_title: "Kilder vi Søger Igennem",
    social_media: {
      name: "Sociale Medier",
      description:
        "Krydshenvisninger på store sociale netværk og offentlige profiler.",
    },
    web: {
      name: "Web",
      description:
        "Scanner det åbne web for offentligt tilgængelige ansigtdata.",
    },
    scammers: {
      name: "Svindlere",
      description:
        "Matcher mod kendte svindler-identitets- og svindeldatabaser.",
    },
    sexual_offenders: {
      name: "Seksualforbrydere",
      description:
        "Krydshenvisninger med offentlige registrerede gerningsmænds registre.",
    },
    videos: {
      name: "Videoer",
      description:
        "Ekstraherer og matcher ansigter fra offentlige videoplat-forme.",
    },
    police_photos: {
      name: "Politifotos",
      description: "Sammenligner med offentligt tilgængelige politidatabaser.",
    },
    news_and_blogs: {
      name: "Nyheder & Blogs",
      description: "Søger i nyhedsarkiver, redaktionelt indhold og blogs.",
    },
  },
  header: {
    scan: "SCAN",
    history: "HISTORIK",
    pricing: "PRISER",
    account: "KONTO",
    logout: "LOG UD",
    app_name: "Digital Forensicist",
  },
  footer: {
    copyright:
      "© 2024 Digital Forensicist. Alle rettigheder forbeholdes. Præcis Identitetsbekræftelse.",
    privacy: "Privatlivspolitik",
    terms: "Servicevilkår",
    docs: "Dokumentation",
    support: "Support",
  },
  common: {
    loading: "Indlæser...",
    error: "Fejl",
    cancel: "Annuller",
    back: "Tilbage",
  },
  errors: {
    upload_failed: "Upload mislykkedes. Prøv igen.",
    not_enough_tokens: "Du har ikke nok tokens til at udføre denne søgning.",
  },
  login: {
    disclaimer:
      "Du har brug for en konto for at bruge denne app. Vi sender ikke spam og deler ikke din e-mail. Vi foreslår, at du logger ind med Apple for at beskytte dit privatliv.",
  },
  results: {
    input_source: "INDGANGSKILDE",
    match_thumbnail: "Miniature af matchet",
    extraction_id: "UDTRÆK-ID",
    scan_analysis: "Scanningsanalyse",
    scan_description:
      "Biometrisk omvendt søgning afsluttet. Fandt %{count} potentielle matches i offentlige registre og sociale indekser.",
    col_identity_map: "IDENTITETSKORT",
    col_verification_path: "VERIFIKATIONSSTI",
    col_bio_match_score: "BIO-MATCHSCORE",
    col_action: "HANDLING",
    export_pdf: "Eksporter PDF",
    exporting: "Genererer...",
    verified: "VERIFICERET",
    details: "DETALJER",
    details_tooltip: "Kør præcis ansigtssammenligning",
    details_loading: "Sammenligner...",
    copied: "Kopieret!",
    copy_url: "Kopier URL",
    displaying: "Viser %{count} af %{total} detektioner",
  },
};

export default da;
